
import { Link } from "react-router-dom";

const ButtonType1 = ({type, title, onClick, href, className}) => {
    return (
        <>
            {type === 'link' ? (
                <Link to = {href} className = {`button1 px-6 py-3 text-[#BCBCBC] border-[#BCBCBC] border-[1px] rounded-[8px] uppercase tracking-[1.5px] flex justify-center items-center ${className}`}>
                    {title}
                </Link>    
            ):(
                <button onClick={onClick} className = {`button1 px-6 py-3 text-[#BCBCBC] border-[#BCBCBC] border-[1px] rounded-[8px] uppercase tracking-[1.5px] flex justify-center items-center ${className}`}>
                    {title}
                </button>
            )}
        </>
    )
}

export default ButtonType1;